import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "desktop-plp-v2" */ './Container'));
